import { Injectable } from '@angular/core';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { UserQuery } from '@examdojo/user';
import { BehaviorSubject, tap } from 'rxjs';
import { ActivityHttpService } from './activity-http.service';
import { ActivityHttpModel } from './activity.model';

@Injectable({ providedIn: 'root' })
export class ActivityService {
  constructor(
    private readonly activityHttpService: ActivityHttpService,
    private readonly errorHandlerService: ErrorHandlerService,
    private readonly userQuery: UserQuery,
  ) {}

  readonly activity$ = new BehaviorSubject<ActivityHttpModel | null>(null);

  fetchUserActivity() {
    const userId = this.userQuery.getActiveId()!;
    return this.activityHttpService.fetch(userId).pipe(
      tap((activity) => {
        this.activity$.next(activity);
      }),
      this.errorHandlerService.setHttpErrorMetadata({
        entity: 'activity',
      }),
    );
  }
}
